<!-- 内容列表 -->
<template>
<div class='content'>
  <div v-for="(item, index) in listData" :key='item.id' class="items">
    <div class="item" @click='handleSelected(index, item.id, item.name)'>
      <!-- <div v-if="index === 1 || index === 0" :class="['date', {'ischeckbg': index === 1 }, {'first': index === 0 }]">
        {{item.filteredDate}}
      </div> -->
      <div v-if="isShowMorning">
        <div v-if="index === 1 || index === 0" :class="['date', {'ischeckbg': index === 1 }, {'first': index === 0 }]">
          {{item.filteredDate}}
        </div>
        <div v-else :class="['date']">
          <span class="month">{{item.filteredPublishDateMonth}}</span>
          <span class="day">{{item.filteredPublishDateDay}}</span>
        </div>
      </div>
      <div v-else>
        <div v-if="index === 0" :class="['date', 'ischeckbg']">
          {{item.filteredDate}}
        </div>
        <div v-else :class="['date']">
          <span class="month">{{item.filteredPublishDateMonth}}</span>
          <span class="day">{{item.filteredPublishDateDay}}</span>
        </div>
      </div>
      
      <div  :class="['article', {'borderBtm': index === listData.length - 1 }]">
        <div :class="['name', {'ischeck': item.ischeck}, {'first': index === 0 }, {'today': isShowMorning ? index === 1 : index === 0}]">{{item.name}}</div>
        <span @click.stop='handleCollect(item.isCollected, index, item.id)'  :class="['icon', {'collect': item.isCollected}]"></span>
      </div>

    </div>
  </div>
  <Modal
    :isShow='isShow'
    :title='title'
    :content='content'
    :button='button'
    :tag='login'
    @close='handleClose'
  />
</div>
</template>

<script>
import api from '@edu-fe/api'
import Modal from './modal'
import login from '@edu-fe/login'
export default {
  components: {
    Modal
  },
  data() {
    return {
      mediaData: '',
      isShow: false,
      title: '每日小技巧需要您的登录',
      content: '为什么需要登录？因为需要将课程发放到您的专属账户。',
      button: '了解了，去登录',
      login: true,
    };
  },
  props: {
    listData: Array,
    // mediaData: Object,
    isShowMorning: Boolean,
    handleSelectedPlay: Function,
    getSchedule: Function,
  },
  computed: {},
  watch: {},
  methods: {
    // 收藏
    async handleCollect(isCollected,index,id) {
      if(index === 0 && this.isShowMorning) {
        return this.showToast('本技巧明日才更新哦~')
      }
      // 未登录则登录
      this.handleLogin()
      this.getMedia(id, isCollected, index)
    },
     // 获取视频数据
    async getMedia(id, isCollected, index) {
      const data  = await api.diversion.getMediaData({
        chapterId: id
      })
      if(data.msg = 'success') {
        const status = Number(!isCollected)
        const { courseId, chapterId } = data.data
        // 收藏
        const collect  = await api.diversion.collect(courseId,chapterId,status)()
        if(collect.msg === 'success') {
          status && this.showToast('收藏成功！已帮您同步保存至“才博” APP')
          Vue.set(this.listData[index], 'isCollected', status)

          // this.$emit('getSchedule', id)
        }
      }
    },
    showToast (meg) {
      this.$toast.show({
        message: meg,
        bottom: 70,
        keep: 2000
      })
    },
    handleSelected (item, id, name) {
      if(item === 0 && this.isShowMorning){
        return this.showToast('本技巧明日才更新哦~')
      }
      this.listData.map((ele,index) => {
        Vue.set(this.listData[index], 'ischeck', false)
      })
      Vue.set(this.listData[item], 'ischeck', true)
      this.$emit('handleSelectedPlay', id, name)
    },
    async handleLogin() {
      const wpsSid = await login.getWpsSid()
      console.log(wpsSid,'wpsSid')
      if(!wpsSid) {
        console.log(111)
        this.isShow = true
        return ''
      }
    },
    handleClose() {
      this.isShow = false
    },
  },
  created() {

  },
  mounted() {
  },
}
</script>
<style lang='scss' scoped>
  @charset "UTF-8";

  @import "../../../style/main";

.content {
  width:rem(686);
  width: 100%;
  height: rem(650);
  overflow: auto;
  margin-top: rem(40);
  padding-bottom: rem(130);
  .items {
    .item {
      width: 100%;
      height: rem(124);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .first {
        color: #999999 !important;
      }
      .date {
        width: rem(72);
        height: rem(72);
        background:rgba(153,153,153,0.1);
        border-radius:rem(6);
        border:rem(1) solid rgba(153,153,153,0.3);
        text-align: center;
        font-size: rem(28);
        font-weight:500;
        color: #999;
        line-height:rem(36);
        margin-left: rem(35);
        .month {
          display: block;
          border-bottom: rem(1) solid rgba(153,153,153,.4);
        }
        .day {
          color: #666;
          font-size: rem(34);
        }
      }
      .ischeckDate {
        background: #FB5B24;
        color: #fff !important;
        .month {
          border-bottom: 1px solid #fff !important;
        }
        .day {
          color: #fff !important;
        }
      }
      .ischeckbg {
        background: #FB5B24;
        color:rgba(255,255,255,1);
      }
      .borderBtm {
        border: none !important;
      }
      .article {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: rem(1) solid #E3E3E3;
        margin-left: rem(33);
        .name {
          width:rem(450);
          font-size:rem(30);
          font-weight:400;
          color:#333;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        .icon {
          width:rem(32);
          height:rem(32);
          display: block;
          margin-right: rem(65);
          background:url('../../../assets/icons/diversion_collect_normal.png') no-repeat right center;
          background-size: rem(32) rem(32);
          padding: rem(30);
          z-index: 999;
        }
        .collect {
          background:url('../../../assets/icons/diversion_collect_selected.png') no-repeat right center;
          background-size: rem(32) rem(32);
        }
        .today {
          color: #FB5B24 !important;
        }
        .ischeck {
          color: #4BCC5A !important;
        }
      }
    }
  }
}
//@import url(); 引入公共css类

</style>
